module.exports = {
      id: "icons:linkedin-circle-usage",
      viewBox: "0 0 1024 1024",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#icons:linkedin-circle-usage",
      toString: function () {
        return this.url;
      }
    }